// extracted by mini-css-extract-plugin
export default {"rootClassName":"custom-text-field"};